module.exports = __webpack_public_path__ + "39739a4040f38c7518240bf3ecf3b7f7.pdf";